/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerlijn_Bewegenopmuziek4Inputs */

const nl_enums_leerlijn_bewegenopmuziek4 = /** @type {(inputs: Enums_Leerlijn_Bewegenopmuziek4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewegen op muziek`)
};

/**

* @param {Enums_Leerlijn_Bewegenopmuziek4Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerlijn_bewegenopmuziek4 = /** @type {((inputs?: Enums_Leerlijn_Bewegenopmuziek4Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerlijn_Bewegenopmuziek4Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerlijn_bewegenopmuziek4(inputs)
});
export { enums_leerlijn_bewegenopmuziek4 as "enums.Leerlijn.BewegenOpMuziek" }